import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Asset } from '@app/models/company/asset.model';
import { AssetForm } from '@app/modules/forms/company/components';
import { AuthService, NotifyService } from '@app/services';
import { TranslatableKey } from '@app/types/translatable.type';

@Component({
    templateUrl: './assets-store.template.html',
    styleUrls: ['./assets-store.style.scss'],
})
export class AssetsStoreView {
    isLoading = false;
    title: TranslatableKey = 'company.assets.addAnAsset';
    asset: Asset = new Asset();

    newAsset = true;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private auth: AuthService
    ) {
        if (this.route.snapshot.data.models) {
            this.title = 'company.assets.editAssetDetails';
            this.asset = this.route.snapshot.data.models.get('asset');
            this.newAsset = false;
        }
    }

    cancel(event: MouseEvent): void {
        event.preventDefault();
        this.router.navigate(['/company', 'assets']);
    }

    async save(assetForm: AssetForm): Promise<void> {
        assetForm.submit();

        if (assetForm.form.invalid) {
            return;
        }
        this.isLoading = true;
        this.asset.companyId = this.auth.company.id;

        try {
            await this.asset.save();

            if (this.asset.getAssignee() && this.newAsset) {
                this.asset.assignment.assetId = this.asset.id;

                await this.asset.assignment.param('asset', this.asset.assignment.assetId).save();
            }

            this.router.navigate(['..'], { relativeTo: this.route });
            this.notify.success('company.assets.assetSaved');
            this.isLoading = false;
        } catch (err) {
            this.isLoading = false;
            this.notify.error(err);
        }
    }
}
